// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Contact } from './contact';
import { MailingList } from './mailing-list';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContactMailingList extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  contactId!: number;
  mailingListId!: number;
  ts!: string;
  contact!: Contact;
  mailingList!: MailingList;
}

